// extracted by mini-css-extract-plugin
export default {"wrapper":"ToolTip_wrapper__JeYxq","upAndDown":"ToolTip_upAndDown__LR3hr","pointer":"ToolTip_pointer__Kwdbc"};